import { createContext } from "react"

export const SearchCtx = createContext(null)
